module.exports = __webpack_public_path__ + "media/images/other-images/mobile-clock-wallpaper-e0bec2298b4d75502dc8499b7dee3361.jpg";